// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreateContent_wrapper__1ri6N","content":"CreateContent_content__3YK4r"};